export default __webpack_public_path__ + "ui/assets/img/info-light-blue-24.svg";